/**
 * shell.jsx — "casca" do painel admin: Sidebar, Topbar, busca global (Ctrl+K) e central de notificações.
 * Recebe `apiFetch` e `onNavigate(page, payload)` por props (não importa nada do App.jsx → sem ciclo).
 */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Icon, Avatar, Btn, Chip, tempoRel, Empty, Skeleton } from "./ui";

export const NAV_GROUPS = [
  { label: "Operação", items: [
    { id: "dashboard", icon: "dashboard", label: "Dashboard" },
    { id: "empresas", icon: "building", label: "Empresas" },
    { id: "usuarios", icon: "users", label: "Usuários" },
    { id: "assinaturas", icon: "dollar", label: "Assinaturas" },
    { id: "financeiro", icon: "chart", label: "Financeiro" },
    { id: "calendario", icon: "calendar", label: "Calendário" },
  ] },
  { label: "Vendas", items: [
    { id: "leads", icon: "target", label: "Leads", badgeKey: "leads" },
    { id: "trial", icon: "flask", label: "Trial" },
    { id: "whatsapp", icon: "whatsapp", label: "WhatsApp", badgeKey: "whatsapp" },
    { id: "propostas", icon: "clipboard", label: "Propostas" },
    { id: "contratos", icon: "file", label: "Contratos" },
  ] },
  { label: "Monitoramento", items: [
    { id: "mapa", icon: "map", label: "Mapa Operacional" },
    { id: "cacambasRua", icon: "truck", label: "Caçambas na Rua" },
    { id: "monitoramento", icon: "eye", label: "Monitoramento" },
    { id: "seguranca", icon: "shield", label: "Segurança & Logs", badgeKey: "seguranca" },
    { id: "emails", icon: "mail", label: "E-mails Enviados" },
  ] },
  { label: "Outros", items: [
    { id: "modulos", icon: "puzzle", label: "Módulos Adicionais" },
    { id: "ia", icon: "bot", label: "Perguntas IA" },
  ] },
];
export const PAGE_INFO = {};
NAV_GROUPS.forEach(g => g.items.forEach(i => { PAGE_INFO[i.id] = i; }));
PAGE_INFO.reunioes = { id: "reunioes", icon: "calendar", label: "Reuniões" };

export const ShellStyles = () => (
  <style>{`
    .adm-sidebar { width: var(--sidebar-w); background: var(--c-sidebar); color: var(--c-sidebar-text); display: flex; flex-direction: column; height: 100vh; height: 100dvh; position: fixed; left: 0; top: 0; z-index: 100; }
    .sb-logo { height: var(--topbar-h); display: flex; align-items: center; gap: 10px; padding: 0 16px; border-bottom: 1px solid rgba(255,255,255,.06); flex-shrink: 0; }
    .sb-logo img { width: 30px; height: 30px; object-fit: contain; border-radius: 8px; background: #fff; padding: 3px; }
    .sb-logo .n { color: #fff; font-weight: 800; font-size: 14px; letter-spacing: -.2px; line-height: 1.1; }
    .sb-logo .n span { color: var(--c-primary); }
    .sb-logo .s { color: var(--c-sidebar-muted); font-size: 10px; font-weight: 600; margin-top: 2px; }
    .sb-nav { flex: 1; overflow-y: auto; padding: 10px 10px 16px; }
    .sb-group { font-size: 10px; font-weight: 700; letter-spacing: .8px; text-transform: uppercase; color: var(--c-sidebar-muted); padding: 14px 10px 6px; }
    .sb-item { display: flex; align-items: center; gap: 11px; width: 100%; padding: 9px 11px; border-radius: 9px; border: none; background: transparent; color: var(--c-sidebar-text); font-size: 13.5px; font-weight: 500; cursor: pointer; text-align: left; margin-bottom: 2px; transition: background .12s, color .12s; position: relative; }
    .sb-item:hover { background: rgba(255,255,255,.05); color: #fff; }
    .sb-item.active { background: rgba(26,174,158,.14); color: #fff; font-weight: 600; }
    .sb-item.active::before { content: ""; position: absolute; left: -10px; top: 8px; bottom: 8px; width: 3px; border-radius: 0 3px 3px 0; background: var(--c-primary); }
    .sb-item.active .ui-ico { color: var(--c-primary); }
    .sb-item .lbl { flex: 1; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .sb-foot { padding: 12px; border-top: 1px solid rgba(255,255,255,.06); display: flex; align-items: center; gap: 10px; }
    .sb-foot .nm { color: #fff; font-size: 13px; font-weight: 600; line-height: 1.2; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .sb-foot .rl { color: var(--c-sidebar-muted); font-size: 11px; }
    .sb-foot .out { margin-left: auto; width: 32px; height: 32px; border-radius: 8px; border: none; background: rgba(255,255,255,.05); color: var(--c-sidebar-text); display: inline-flex; align-items: center; justify-content: center; cursor: pointer; }
    .sb-foot .out:hover { background: rgba(229,72,77,.18); color: #ff8a8e; }

    .adm-topbar { position: fixed; top: 0; left: var(--sidebar-w); right: 0; height: var(--topbar-h); background: rgba(255,255,255,.85); backdrop-filter: saturate(180%) blur(10px); -webkit-backdrop-filter: saturate(180%) blur(10px); border-bottom: 1px solid var(--c-border); z-index: 900; display: flex; align-items: center; gap: 10px; padding: 0 22px; }
    .tb-title { font-size: 15px; font-weight: 700; color: var(--c-text); display: flex; align-items: center; gap: 8px; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .tb-title .ui-ico { color: var(--c-text-3); }
    .tb-search { margin-left: auto; display: flex; align-items: center; gap: 8px; height: 36px; padding: 0 10px 0 12px; border-radius: var(--r); border: 1px solid var(--c-border-2); background: var(--c-surface); color: var(--c-text-3); font-size: 13px; cursor: text; width: 280px; transition: border-color .15s, box-shadow .15s; }
    .tb-search:hover { border-color: #c3cad6; }
    .tb-search .ph { flex: 1; text-align: left; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0; }
    .tb-ico { width: 36px; height: 36px; border-radius: var(--r); border: 1px solid transparent; background: transparent; color: var(--c-text-2); display: inline-flex; align-items: center; justify-content: center; cursor: pointer; position: relative; }
    .tb-ico:hover { background: var(--c-surface-2); border-color: var(--c-border); color: var(--c-text); }
    .tb-ico .ui-count { position: absolute; top: -4px; right: -4px; border: 2px solid #fff; }
    .tb-burger { display: none; }
    .adm-main { margin-left: var(--sidebar-w); padding: calc(var(--topbar-h) + 22px) 28px 40px; min-height: 100vh; }

    /* busca global */
    .cmd-overlay { position: fixed; inset: 0; background: rgba(16,24,40,.5); backdrop-filter: blur(3px); z-index: 9998; display: flex; align-items: flex-start; justify-content: center; padding: 12vh 16px 16px; }
    .cmd { width: 100%; max-width: 620px; background: var(--c-surface); border-radius: var(--r-xl); box-shadow: var(--sh-lg); overflow: hidden; animation: uiPop .15s ease; display: flex; flex-direction: column; max-height: 70vh; }
    .cmd-in { display: flex; align-items: center; gap: 10px; padding: 6px 14px; border-bottom: 1px solid var(--c-border); }
    .cmd-in input { flex: 1; border: none !important; outline: none; background: transparent !important; font-size: 15px; height: 44px; min-height: 0 !important; padding: 0 !important; color: var(--c-text); box-shadow: none !important; border-radius: 0; }
    .cmd-body { overflow: auto; padding: 6px; }
    .cmd-grp { font-size: 10.5px; font-weight: 700; letter-spacing: .6px; text-transform: uppercase; color: var(--c-text-3); padding: 10px 10px 4px; }
    .cmd-it { display: flex; align-items: center; gap: 11px; padding: 8px 10px; border-radius: var(--r); cursor: pointer; border: none; background: none; width: 100%; text-align: left; color: var(--c-text); }
    .cmd-it.sel, .cmd-it:hover { background: var(--c-surface-2); }
    .cmd-it .ic { width: 32px; height: 32px; border-radius: 8px; display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .cmd-it .t { font-size: 13.5px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .cmd-it .s { font-size: 12px; color: var(--c-text-3); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .cmd-foot { display: flex; gap: 14px; padding: 8px 14px; border-top: 1px solid var(--c-border); font-size: 11.5px; color: var(--c-text-3); background: var(--c-surface-2); }

    /* notificações */
    .ntf-panel { position: absolute; top: calc(100% + 8px); right: 0; width: 400px; max-height: min(70vh, 620px); background: var(--c-surface); border: 1px solid var(--c-border); border-radius: var(--r-lg); box-shadow: var(--sh-lg); display: flex; flex-direction: column; overflow: hidden; animation: uiPop .15s ease; z-index: 950; }
    .ntf-head { display: flex; align-items: center; justify-content: space-between; padding: 12px 14px; border-bottom: 1px solid var(--c-border); font-weight: 800; font-size: 14px; }
    .ntf-list { overflow: auto; padding: 6px; }
    .ntf-it { display: flex; gap: 11px; padding: 10px; border-radius: var(--r); cursor: pointer; border: none; background: none; width: 100%; text-align: left; align-items: flex-start; }
    .ntf-it:hover { background: var(--c-surface-2); }
    .ntf-it .ic { width: 34px; height: 34px; border-radius: 10px; display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .ntf-it .t { font-size: 13px; font-weight: 600; color: var(--c-text); line-height: 1.3; }
    .ntf-it .s { font-size: 12px; color: var(--c-text-3); margin-top: 2px; line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
    .ntf-it .w { font-size: 11px; color: var(--c-text-3); white-space: nowrap; margin-left: auto; padding-left: 6px; }

    @media (max-width: 768px) {
      .adm-topbar { left: 0; padding: 0 10px; gap: 4px; }
      .tb-burger { display: inline-flex; }
      .tb-search { width: 36px; padding: 0; justify-content: center; border-color: transparent; background: transparent; margin-left: auto; }
      .tb-search .ph, .tb-search .ui-kbd { display: none; }
      .tb-title { font-size: 15px; }
      .adm-main { margin-left: 0; padding: calc(var(--topbar-h) + 12px) 12px calc(24px + env(safe-area-inset-bottom)); }
      .adm-sidebar { display: none; }
      .adm-sidebar.open { display: flex; width: min(82vw, 300px); z-index: 9990; box-shadow: 8px 0 40px rgba(0,0,0,.45); animation: admDrawer .22s ease; }
      .adm-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.45); z-index: 9989; }
      .cmd-overlay { padding: 0; align-items: stretch; }
      .cmd { max-width: none; max-height: none; border-radius: 0; height: 100dvh; }
      .ntf-panel { position: fixed; top: var(--topbar-h); left: 0; right: 0; width: auto; max-height: calc(100dvh - var(--topbar-h)); border-radius: 0; border-left: none; border-right: none; }
    }
  `}</style>
);

export function Sidebar({ page, setPage, admin, onLogout, mobileOpen, badges = {} }) {
  return (
    <aside className={"adm-sidebar" + (mobileOpen ? " open" : "")}>
      <div className="sb-logo">
        <img src="/logo-icon.png" alt="" />
        <div style={{ minWidth: 0 }}><div className="n">Controla <span>Caçambas</span></div><div className="s">PAINEL ADMIN</div></div>
      </div>
      <nav className="sb-nav">
        {NAV_GROUPS.map(g => (
          <div key={g.label}>
            <div className="sb-group">{g.label}</div>
            {g.items.map(it => {
              const b = it.badgeKey ? badges[it.badgeKey] : 0;
              return (
                <button key={it.id} className={"sb-item" + (page === it.id ? " active" : "")} onClick={() => setPage(it.id)}>
                  <Icon name={it.icon} size={17} /><span className="lbl">{it.label}</span>
                  {b > 0 && <span className="ui-count">{b > 99 ? "99+" : b}</span>}
                </button>
              );
            })}
          </div>
        ))}
      </nav>
      <div className="sb-foot">
        <Avatar name={admin?.nome || "Admin"} size={34} />
        <div style={{ minWidth: 0 }}><div className="nm">{admin?.nome || "Admin"}</div><div className="rl">Super Admin</div></div>
        <button className="out" onClick={onLogout} title="Sair" aria-label="Sair"><Icon name="logout" size={16} /></button>
      </div>
    </aside>
  );
}

export function Topbar({ page, onBurger, onSearch, notif, admin }) {
  const info = PAGE_INFO[page] || { label: "" };
  return (
    <header className="adm-topbar">
      <button className="tb-ico tb-burger" onClick={onBurger} aria-label="Menu"><Icon name="menu" size={20} /></button>
      <div className="tb-title"><Icon name={info.icon || "dashboard"} size={17} />{info.label}</div>
      <button className="tb-search" onClick={onSearch} aria-label="Buscar">
        <Icon name="search" size={16} /><span className="ph">Buscar empresa, usuário, lead…</span><span className="ui-kbd">Ctrl K</span>
      </button>
      {notif}
      <div className="ui-hide-m" style={{ marginLeft: 4 }}><Avatar name={admin?.nome || "Admin"} size={32} /></div>
    </header>
  );
}

/* ───────────────────────── Busca global (Ctrl+K) ───────────────────────── */
const TIPO_ICO = { empresa: ["building", "var(--c-primary)"], usuario: ["user", "var(--c-info)"], lead: ["target", "var(--c-purple)"], conversa: ["whatsapp", "#25d366"], pagina: ["arrow-right", "var(--c-text-3)"] };
const fmtTel = (n) => { const d = String(n || "").replace(/\D/g, ""); const m = d.match(/^55(\d{2})(\d{4,5})(\d{4})$/); return m ? `(${m[1]}) ${m[2]}-${m[3]}` : n; };

export function CommandPalette({ open, onClose, apiFetch, onNavigate }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sel, setSel] = useState(0);
  const inputRef = useRef(null);
  const seq = useRef(0);

  useEffect(() => { if (open) { setQ(""); setRes(null); setSel(0); setTimeout(() => inputRef.current && inputRef.current.focus(), 30); } }, [open]);
  useEffect(() => {
    if (!open) return undefined;
    const t = q.trim();
    if (t.length < 2) { setRes(null); setLoading(false); return undefined; }
    setLoading(true);
    const id = ++seq.current;
    const h = setTimeout(() => apiFetch("/api/admin/shell/busca?q=" + encodeURIComponent(t)).then(r => { if (id === seq.current) { setRes(r); setSel(0); } }).catch(() => { if (id === seq.current) setRes({ empresas: [], usuarios: [], leads: [], conversas: [] }); }).finally(() => { if (id === seq.current) setLoading(false); }), 220);
    return () => clearTimeout(h);
  }, [q, open, apiFetch]);

  const itens = useMemo(() => {
    const t = q.trim().toLowerCase();
    const out = [];
    const norm = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
    const paginas = Object.values(PAGE_INFO).filter(p => p.id !== "reunioes" && (!t || norm(p.label).includes(norm(t))));
    if (res) {
      (res.empresas || []).forEach(e => out.push({ tipo: "empresa", grupo: "Empresas", t: e.nome, s: [e.email, e.tel && fmtTel(e.tel)].filter(Boolean).join(" · "), chip: e.status, go: () => onNavigate("empresas", { tenantId: e.id }) }));
      (res.usuarios || []).forEach(u => out.push({ tipo: "usuario", grupo: "Usuários", t: u.nome, s: [u.login, u.tenant_nome].filter(Boolean).join(" · "), chip: u.status, go: () => onNavigate("usuarios", { busca: u.login || u.nome }) }));
      (res.leads || []).forEach(l => out.push({ tipo: "lead", grupo: "Leads", t: l.nome, s: [l.empresa, fmtTel(l.tel)].filter(Boolean).join(" · "), chip: l.status, go: () => onNavigate("leads", { leadId: l.id }) }));
      (res.conversas || []).forEach(c => out.push({ tipo: "conversa", grupo: "Conversas do WhatsApp", t: c.nome_contato || c.tenant_nome || fmtTel(c.numero), s: c.ultima_msg || fmtTel(c.numero), go: () => onNavigate("whatsapp", { numero: c.numero }) }));
    }
    paginas.slice(0, t ? 4 : 8).forEach(p => out.push({ tipo: "pagina", grupo: "Ir para", t: p.label, s: "Página", icon: p.icon, go: () => onNavigate(p.id) }));
    return out;
  }, [res, q, onNavigate]);

  useEffect(() => { setSel(s => Math.min(s, Math.max(0, itens.length - 1))); }, [itens.length]);

  const onKey = (e) => {
    if (e.key === "ArrowDown") { e.preventDefault(); setSel(s => Math.min(itens.length - 1, s + 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setSel(s => Math.max(0, s - 1)); }
    else if (e.key === "Enter") { e.preventDefault(); const it = itens[sel]; if (it) { it.go(); onClose(); } }
    else if (e.key === "Escape") onClose();
  };
  if (!open) return null;
  let grupo = null;
  return (
    <div className="cmd-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="cmd" role="dialog" aria-label="Busca">
        <div className="cmd-in">
          <Icon name="search" size={18} color="var(--c-text-3)" />
          <input ref={inputRef} value={q} onChange={e => setQ(e.target.value)} onKeyDown={onKey} placeholder="Empresa, usuário, lead, telefone, CNPJ ou página…" />
          {loading ? <Icon name="loader" size={16} color="var(--c-text-3)" style={{ animation: "uiSpin 1s linear infinite" }} /> : <button className="tb-ico ui-only-m" onClick={onClose} aria-label="Fechar"><Icon name="x" size={18} /></button>}
        </div>
        <div className="cmd-body">
          {itens.length === 0 && !loading && <Empty icon="search" title={q.trim().length < 2 ? "Digite pelo menos 2 letras" : "Nada encontrado"} text={q.trim().length < 2 ? "Busca em empresas, usuários, leads e conversas." : "Tente outro nome, telefone ou e-mail."} style={{ padding: "30px 20px" }} />}
          {itens.map((it, i) => {
            const head = it.grupo !== grupo ? <div className="cmd-grp">{it.grupo}</div> : null; grupo = it.grupo;
            const [ico, cor] = TIPO_ICO[it.tipo];
            return (
              <React.Fragment key={i}>
                {head}
                <button className={"cmd-it" + (i === sel ? " sel" : "")} onMouseEnter={() => setSel(i)} onClick={() => { it.go(); onClose(); }}>
                  <span className="ic" style={{ background: cor + "1f", color: cor }}><Icon name={it.icon || ico} size={16} /></span>
                  <span style={{ minWidth: 0, flex: 1 }}><div className="t">{it.t}</div>{it.s && <div className="s">{it.s}</div>}</span>
                  {it.chip && <Chip color={({ ativo: "green", trial: "blue", suspenso: "amber", cancelado: "red", novo: "blue", respondeu: "green", em_analise: "amber", aprovado: "teal", recusado: "red" })[it.chip] || "gray"}>{it.chip.replace("_", " ")}</Chip>}
                </button>
              </React.Fragment>
            );
          })}
        </div>
        <div className="cmd-foot ui-hide-m"><span><span className="ui-kbd">↑↓</span> navegar</span><span><span className="ui-kbd">Enter</span> abrir</span><span><span className="ui-kbd">Esc</span> fechar</span></div>
      </div>
    </div>
  );
}

/** Atalho global Ctrl+K / Cmd+K (e "/" fora de campos) */
export function useCommandShortcut(setOpen) {
  useEffect(() => {
    const h = (e) => {
      const tag = (e.target && e.target.tagName) || "";
      const emCampo = /INPUT|TEXTAREA|SELECT/.test(tag) || (e.target && e.target.isContentEditable);
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") { e.preventDefault(); setOpen(o => !o); }
      else if (e.key === "/" && !emCampo && !e.ctrlKey && !e.metaKey && !e.altKey) { e.preventDefault(); setOpen(true); }
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [setOpen]);
}

/* ───────────────────────── Central de notificações ───────────────────────── */
const NTF_ICO = { lead: ["target", "var(--c-purple)"], whatsapp: ["whatsapp", "#25d366"], trial: ["flask", "var(--c-info)"], boleto: ["receipt", "var(--c-warn)"], erro: ["alert", "var(--c-danger)"], seguranca: ["shield", "var(--c-danger)"] };

export function NotifCenter({ apiFetch, onNavigate, segAlertas = [], onCounts }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  const carregar = useCallback(() => {
    setLoading(true);
    return apiFetch("/api/admin/shell/notificacoes").then(d => { setData(d); onCounts && onCounts(d); }).catch(() => {}).finally(() => setLoading(false));
  }, [apiFetch, onCounts]);
  useEffect(() => { carregar(); const t = setInterval(carregar, 2 * 60 * 1000); return () => clearInterval(t); }, [carregar]);
  useEffect(() => { if (open) carregar(); }, [open, carregar]);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const esc = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", close); document.addEventListener("keydown", esc);
    return () => { document.removeEventListener("mousedown", close); document.removeEventListener("keydown", esc); };
  }, [open]);

  const itens = useMemo(() => {
    const seg = (segAlertas || []).filter(a => !a.visto).slice(0, 6).map(a => ({ tipo: "seguranca", id: "seg-" + a.chave, titulo: a.titulo, texto: a.descricao, page: "seguranca", prioridade: a.severidade === "alta" ? 1 : 2 }));
    return [...seg, ...((data && data.itens) || [])].sort((a, b) => a.prioridade - b.prioridade);
  }, [data, segAlertas]);
  const total = itens.length;

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button className="tb-ico" onClick={() => setOpen(o => !o)} aria-label="Notificações" title="Notificações">
        <Icon name="bell" size={19} />{total > 0 && <span className="ui-count">{total > 99 ? "99+" : total}</span>}
      </button>
      {open && (
        <div className="ntf-panel">
          <div className="ntf-head">
            <span>Notificações {total > 0 && <span className="ui-muted" style={{ fontWeight: 600, fontSize: 12.5 }}>· {total}</span>}</span>
            <div className="ui-row"><Btn size="sm" variant="ghost" icon="refresh" loading={loading} onClick={carregar} title="Atualizar" /><button className="tb-ico ui-only-m" onClick={() => setOpen(false)} aria-label="Fechar"><Icon name="x" size={18} /></button></div>
          </div>
          <div className="ntf-list">
            {loading && !data && <div style={{ padding: 10 }}><Skeleton lines={4} h={14} /></div>}
            {!loading && total === 0 && <Empty icon="circle-check" title="Tudo em dia" text="Nenhuma pendência no momento." style={{ padding: "34px 20px" }} />}
            {itens.map(it => {
              const [ico, cor] = NTF_ICO[it.tipo] || NTF_ICO.lead;
              return (
                <button key={it.id} className="ntf-it" onClick={() => { setOpen(false); onNavigate(it.page, it.payload); }}>
                  <span className="ic" style={{ background: cor + "1f", color: cor }}><Icon name={ico} size={17} /></span>
                  <span style={{ minWidth: 0, flex: 1 }}><div className="t">{it.titulo}</div>{it.texto && <div className="s">{it.texto}</div>}</span>
                  {it.quando && <span className="w">{tempoRel(it.quando)}</span>}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
